export const isExternalPopup = window.location.href.includes('tabId=')
export const isSidePanel = window.location.href.includes('sidepanel.html')

export const getWindowDimensions = () => ({
  height: window.innerHeight,
  width: window.innerWidth,
})
